export enum CUSTOM_ICONS {
  GUIDE = 'guide',
  PERMISSION = 'permission',
  DASHBOARD = 'dashboard',
  ACCOUNT = 'account',
  DOCUMENTATION = 'documentation',
  FAN_OFF = 'fan-off',
  FAN_ON_ONE = 'fan-on-one',
  FAN_ON_TWO = 'fan-on-two',
  FAN_ON_THREE = 'fan-on-three',
  MOTION_ON = 'motion-on',
  MOTION_OFF = 'motion-off',
  AVAILABLE = 'available',
  BUSY = 'busy',
  CONNECTION_ON = 'connection-on',
  CONNECTION_OFF = 'connection-off'
}
